import { render, staticRenderFns } from "./FileUploadWidget.vue?vue&type=template&id=07c54fb8&"
import script from "./FileUploadWidget.vue?vue&type=script&lang=js&"
export * from "./FileUploadWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports